import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { updateOrg } from '../action/org/update-org';
import { loadEmployeeDirectoryImports } from '../employee-directory-import/actions/load-employee-directory-imports';
import { employeeDirectoryImportForOrgIdSelector } from '../employee-directory-import/employee-directory-import-selectors';
import { loadOrg } from '../organization/actions/load-org';
import { orgSelector } from '../reducers/org-selectors';

import { UiButton } from '../ui/ui-button';

import { EmployeeListUploadDialog } from './employee-list-upload-dialog';

const mapStateToProps = (state: any, { orgId }: InputProps) => ({
  org: orgSelector(state, orgId),
  employeeDirectoryImports: employeeDirectoryImportForOrgIdSelector(state, orgId),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { orgId }: InputProps,
) => ({
  actions: {
    loadOrg: () => dispatch(loadOrg(orgId)),
    updateOrg: (update: Partial<Org>) => dispatch(updateOrg(orgId, update)),
    loadEmployeeDirectoryImports: () => dispatch(loadEmployeeDirectoryImports(orgId)),
  },
});

type InputProps = {
  orgId: number;
  size?: 'sm';
  hideRequestSentDialog?: boolean;
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & StateProps & DispatchProps;

export const EmployeeListUpload = connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: Props) => {
  const { hideRequestSentDialog, size, org, employeeDirectoryImports, actions } = props;

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState<boolean>(false);

  useEffect(() => {
    actions.loadOrg();
    actions.loadEmployeeDirectoryImports();
  });

  const handleToggleDialog = () => setIsConfirmDialogOpen(!isConfirmDialogOpen);

  const hasEmployeeList = Boolean(org?.employeeListPath || employeeDirectoryImports.length > 0);

  return (
    <>
      {org ? (
        <UiButton
          size={size}
          variant={hasEmployeeList ? 'tertiary' : 'secondary'}
          className="u-margin-left-md"
          onClick={handleToggleDialog}
        >
          Upload {hasEmployeeList ? 'another' : 'a'} list
        </UiButton>
      ) : null}
      {org && isConfirmDialogOpen && (
        <EmployeeListUploadDialog
          org={org}
          hasEmployeeList={hasEmployeeList}
          hideRequestSentDialog={hideRequestSentDialog}
          closeDialog={handleToggleDialog}
        />
      )}
    </>
  );
});
